import axiosInstance from "../interceptor/interceptor";
import userApplicationServiceDictionary from "../dictionary/userApplicationDictionary";

export const fetchUserApplications = (token: string, statusFilter?: string) => {
  return axiosInstance.post(
    userApplicationServiceDictionary.getApplication(token, statusFilter),
    {
      headers: {
        authorization: `Bearer ${token}`,
      },
    }
  );
};

export const fetchUserApplicationsFormData = (
  token: string,
  applicationId: string
) => {
  if (applicationId) {
    return axiosInstance.post(
      userApplicationServiceDictionary.getApplicationFormData(
        token,
        applicationId
      ),
      {},
      {
        headers: {
          authorization: `Bearer ${token}`,
        },
      }
    );
  }
};
